export enum Domains {
    VF = 'https://eweb8.vfd2-testnet.de',
    ZUHAUSEPLUS = 'https://zuhauseplus.vodafone.de',
    ST = 'https://simplicity.wf-de.vodafone.com',
}

export enum Endpoints {
    FF = '/api/friends-and-family/validate',
    LMS = '/api/ftth',
    BID = '/api/bid'
}

export enum QueryNames {
    TARIFF = 'product',
    FF = 'ffv2',
    BASKET = 'vfBasket',
    TARGET = 'target'
}

export enum HttpStatus {
    UNAUTHORIZED = 401
}

export enum Cookies {
    ADDRESS = 'address',
    FF = 'vfhvalueffv2',
    BASKET = 'pdpBasket',
    ZHP_LM_MODULE = 'ftth',
    OSHOP = 'oshop',
}

export enum LandingPagePath {
    DSL = '/privat/internet/dsl.html',
    CABLE = '/privat/internet/kabel.html',
    GIGACUBE = '/privat/internet/gigacube.html',
    FIBER = '/privat/internet/glasfaser.html'
}

export enum BasketPath {
    OPTION = '/optionen/',
}
